// ═══════════════════════════════════════════════════════════════════════════
// openCreatorByUsername — canonical way to open another creator's public
// profile from anywhere in the app.
//
// Priority order:
//   1. If the creator has a username, go to /@<username> (the real public
//      front-end page, shareable link, SEO-friendly).
//   2. If no username but we have a user_id, fall back to the inline
//      CreatorProfilePage via onFallback (callers wire their local "open
//      panel" handler in).
//   3. If neither, return false and let the caller decide (e.g., toast or
//      no-op on a seed creator).
//
// Returns true when the navigation/fallback was handled, false otherwise.
// ═══════════════════════════════════════════════════════════════════════════

export function openCreatorByUsername(creator, onFallback) {
  const username = (creator?.username || '').trim();
  if (username) {
    try {
      window.location.href = `/@${username.toLowerCase()}`;
      return true;
    } catch {
      /* fall through to in-app */
    }
  }
  if (typeof onFallback === 'function') {
    onFallback();
    return true;
  }
  return false;
}

/**
 * Build the canonical public-profile URL for sharing. Falls back to a
 * hash-style creator link when the profile has no username yet.
 */
export function publicCreatorUrl(creator) {
  const origin = (typeof window !== 'undefined' && window.location.origin) || '';
  const username = (creator?.username || '').trim().toLowerCase();
  if (username) return `${origin}/@${username}`;
  const slug = (creator?.host || creator?.full_name || '')
    .toLowerCase()
    .replace(/\s+/g, '-');
  return `${origin}/#creator/${slug}`;
}
